import React from 'react';
import { CheckboxGroup, DatePickerInput, Input, RadioGroup, Select } from "../Shared/Form";
import { actions, useStore } from "../store";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { extrasFormSchema } from "../schema";
import PropTypes from "prop-types";
import { WizardButtons } from "../Wizard";
import { GenerateButton, PrevButton, ResetButton } from "../Shared/Buttons";
import request from "../api/request";
import ReCAPTCHA from "react-google-recaptcha";
import { Modal } from "bootstrap";

const ExtrasStep = ({ stepName }) => {
  const extrasFormData = useStore(state => state.extrasFormData)
  const tokenFlag = useStore(state => state.tokenFlag)
  const setTokenFlag = useStore(state => state.setTokenFlag)

  const [extrasFormValue, setExtrasFormValue, changeExtrasFormValue, changeExtrasFormDataByKey ] =
    useStore(state => [state.extrasFormValue, state.setExtrasFormValue,
      state.changeExtrasFormValue,state.changeExtrasFormDataByKey])
  const removeSuccessSteps = useStore(state => state.removeSuccessSteps)

  const [modal, setModal] = React.useState(null)
  const exampleModal = React.useRef()

  const formMethods = useForm({
    mode: 'onBlur',
    shouldFocusError: false,
    resolver: yupResolver(extrasFormSchema),
    defaultValues: extrasFormValue,
  });

  const handleChange = (fieldName, value) => {
    changeExtrasFormValue(fieldName, value)
    removeSuccessSteps(stepName)
  }

  const onSubmit = (data) => {
    setExtrasFormValue(data);

    if(tokenFlag) {
      actions.handleWizardNextStep()
      actions.handleWizardPreviewStep()
    } else {
      modal.show()
    }
  }

  const onChangeCaptcha = token =>  {
    console.log('Check v2')
    request.post('api/privacy-policy/ui/verify_cap', {
      token: token,
      version: 2,
    }).then(response => {
      if(response.data.isValid) {
        setTokenFlag(true);
        modal.hide();
        actions.handleWizardNextStep();
        actions.handleWizardPreviewStep();
      } else {
        setTokenFlag(false);
      }
    }).catch(error => {
      console.log(error, 'error');
    })
  }

  const getCookieBanners = () => {
    request.post('api/privacy-policy/ui/cookie_banners')
      .then(response => {
        if(response.data.banners.length === 0 && extrasFormData.userBanners.length > 0) {
          changeExtrasFormValue('cookieId', '')
          formMethods.setValue('cookieId', '')
        }
        changeExtrasFormDataByKey('userBanners', response.data.banners)
      })
      .catch(error => {
        console.log(error, 'error');
      })
  }

  React.useEffect(() => {
    setModal(
      new Modal(exampleModal.current)
    )
  }, [])

  React.useEffect(() => {
    getCookieBanners()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  return (
    <>
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">
                Almost done, just tell us about your cookie categories and who will handle privacy requests.
              </h3>
            </div>
            <div className="card-body">
              <div className='row'>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold'>What Cookie Categories do you use on your website?</p>
                  <div className='d-flex flex-column'>
                    <CheckboxGroup
                      options={extrasFormData.cookiesCategories}
                      name='cookiesCategories'
                      handleChange={handleChange}
                    />
                  </div>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold'>
                    {extrasFormData.userBanners.length > 0
                      ? 'Select Cookie Item to automatically include your Cookie Report'
                      : 'Enter your Cookie Item ID to automatically include your Cookie Report'}
                  </p>
                  <div className='mb-3'>
                    { extrasFormData.userBanners.length > 0
                      ?
                      <Select
                        name='cookieId'
                        options={extrasFormData.userBanners}
                        handleChange={handleChange}
                        getOptionLabel={option => option.title}
                        getOptionValue={option => option.hash}
                      />
                      :
                      <Input
                        floating={true}
                        labelText='Cookie item ID'
                        name='cookieId'
                        type='text'
                        handleChange={handleChange}
                        placeholder="121241bcd..."
                      />
                    }
                  </div>
                </div>
              </div>
              <div className='row mt-4'>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold'>Do you have a person who will handle privacy-related questions and issues?</p>
                  <div className='d-flex flex-column'>
                    <RadioGroup
                      options={extrasFormData.privacyOfficers}
                      name='privacyOfficer'
                      handleChange={handleChange}
                    />
                  </div>
                </div>
                {extrasFormValue.privacyOfficer !== 'No person, just use company contacts' &&
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold'>Privacy Officer/Data Protection Officer contact details</p>
                  <div className="mb-3">
                    <Input
                      labelText='Name'
                      name='officerName'
                      type='text'
                      handleChange={handleChange}
                      isRequired
                    />
                  </div>
                  <div className="mb-3">
                    <Input
                      labelText='Email'
                      name='officerEmail'
                      type='email'
                      handleChange={handleChange}
                      isRequired
                    />
                  </div>
                  <div className="mb-3">
                    <Input
                      labelText='Phone Number'
                      name='officerPhone'
                      type='text'
                      handleChange={handleChange}
                    />
                  </div>

                </div>
                }
              </div>
              <div className='row mt-4'>
                <div className='col-lg-6 col-md-6 col-sm-12'>
                  <p className='fw-bold required'>What is the effective date of this Privacy Policy?</p>
                  <div className='col-lg-6 col-md-6 col-sm-12'>
                    <DatePickerInput
                      name='effectiveDate'
                      handleChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='card-footer'>
              <WizardButtons>
                <PrevButton onClick={() => actions.handleWizardPrevStep()} />
                <ResetButton onClick={() => actions.handleWizardReset()} />
                <GenerateButton type='submit' />
              </WizardButtons>
            </div>
          </div>
        </form>
      </FormProvider>

      <div className="modal fade" ref={exampleModal} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="d-flex justify-content-center">
                <ReCAPTCHA
                  sitekey="6LemmK4cAAAAAIl_CiNkmgnkp1xYMaCgxY1QH0bL"
                  onChange={onChangeCaptcha}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}

ExtrasStep.propTypes = {
  stepName: PropTypes.string.isRequired,
}

export default ExtrasStep;
